export enum ResultReasonType {
    NotSet = 0,
    Success = 1,
    Error = 2,
    NotFound = 3,
    Invalid = 4,
    Duplicate = 5,
    DuplicateName = 6,
    DuplicateCode = 7,
}
